<section *ngIf="detailForum" class="forum-detail-post position-relative">
  <div class="forum-detail-post__body" style="position: static">
    <div class="content" style="position: static">
      <div class="comments" style="overflow: scroll; max-height: 30rem; position: static">
        <div class="comments__title" style="position: static">
          <!-- Comments -->
          <!-- <div class="add" *ngIf="isLogin == 1" (click)="showMessageBoxReply = !showMessageBoxReply">
            <i class="fa-solid fa-plus-circle"></i>
          </div> -->
        </div>
        <!-- <div class="box-reply" *ngIf="isLogin == 1 && showMessageBoxReply">
          <form (ngSubmit)="storeForumMessageReply()">
            <app-editor [hideToolbar]="true" [(innerValue)]="detailForum.replyText"></app-editor>
            <button class="button-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
          </form>
        </div> -->
        <div class="comments__card" [class.one-row-grid]="hideNonEssential" *ngFor="let reply of detailForum?.replies; let i = index">
          <div class="w-100 d-flex justify-content-end" style="gap: 0.5rem">
            <button class="t-btn" (click)="reactToReply(reply, 1)" [ngStyle]="{ color: reply.haveILiked ? 'var(--secondary)' : 'var(--primary)' }"><i class="fa fa-thumbs-up"></i> {{ reply.likeCount }}</button>
            <button class="t-btn" (click)="reactToReply(reply, 2)" [ngStyle]="{ color: reply.haveIDisliked ? 'var(--secondary)' : 'var(--primary)' }"><i class="fa fa-thumbs-down"></i> {{ reply.dislikeCount }}</button>
          </div>
          <div class="comments__card--left container-char-image" *ngIf="!hideNonEssential" ngbDropdown>
            <app-forum-profile-popup ngbDropdownMenu [user]="reply.user"></app-forum-profile-popup>
            <img loading="lazy" ngbDropdownToggle src="{{ !reply.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + reply.user?.image }}" />
          </div>
          <div class="comments__card--center">
            <div class="comments__card--center__message">
              <div *ngIf="!reply.isEdit" class="text {{ isOwnMessage(reply) ? 'own' : '' }}">
                <div [innerHtml]="reply.message"></div>
              </div>
              <div class="comments__card--center__details">
                <div *ngIf="!reply.isEdit" class="d-flex justify-content-between w-100 mt-1">
                  <div class="header">
                    <div class="name">
                      {{ reply.user?.userName }} {{ reply.reply }}
                      <span *ngIf="!hideNonEssential">{{ isSeller(reply.createdBy) ? "admin" : reply.user?.userType }}</span>
                      <span *ngIf="isLogin == 1" style="position: relative">
                        <span (click)="handleShowOptionForumReply(i)" style="width: 1rem; cursor: pointer; display: inline-flex; align-items: center; justify-content: center">
                          <i class="fa-solid fa-ellipsis-v"></i>
                        </span>
                        <div class="comments__card--center__list--menu" (mouseleave)="handleShowOptionForumReply(i)" [class.d-none]="!reply.showOption">
                          <div class="item" *ngIf="!isModerator()" (click)="editForumMessage($event, reply)"><i class="fa-solid fa-pen"></i> Edit</div>
                          <div class="item" *ngIf="!isModerator()" (click)="deleteForumMessageReply($event, reply.id)"><i class="fa-solid fa-trash"></i> Delete</div>
                          <div class="item" (click)="showReplyMessageBox($event, reply)"><i class="fa-solid fa-comment-dots"></i> Reply</div>
                          <div class="item" (click)="handleReport(reply.id, 'forum_marketplace')"><i class="fa-solid fa-flag"></i> Report</div>
                        </div>
                      </span>
                    </div>
                  </div>
                  {{ formatDate(reply.createdAt) }}
                </div>
                <div *ngIf="reply?.replies.length != 0">{{ reply?.replies.length }} comments</div>
              </div>
            </div>
            <!-- *ngIf="reply.showReply" -->
            <div class="comments__card--center__reply">
              <div class="comments__card--center__reply--card {{ isModerator() ? '' : 'isModerator' }}" *ngFor="let child of reply.replies; let iReply = index">
                <!-- <div class="comments__card--center__reply--card__left">
                  <div class="name">{{ child.user.userName }}</div>
                  <div class="type">{{ child.user.userType }}</div>
                </div> -->
                <div class="comments__card--center__reply--card__center">
                  <div class="name">
                    {{ child.user.userName }}
                    <span>{{ isSeller(child.createdBy) ? "admin" : child.user.userType }}</span>
                  </div>
                  <div *ngIf="!child.isEdit" class="comments__card--center__reply--card__center--message">
                    <div class="text {{ isOwnMessage(child) ? 'own' : '' }}">
                      <div [innerHtml]="child.message"></div>
                      <div class="comments__card--center__reply--card__center--list" *ngIf="!isModerator()">
                        <div class="comments__card--center__reply--card__center--list__bar" (click)="handleShowOptionForumReplyChild(child)">
                          <i class="fa-solid fa-ellipsis-v"></i>
                        </div>
                        <div class="comments__card--center__reply--card__center--list__menu" (mouseleave)="handleShowOptionForumReplyChild(child)" [class.d-none]="!child.showOption">
                          <div class="item" (click)="editForumMessageReply($event, child)"><i class="fa-solid fa-pen"></i> Edit</div>
                          <div class="item" (click)="deleteForumMessageReply($event, child.id, i)"><i class="fa-solid fa-trash"></i> Delete</div>
                          <div class="item" (click)="handleReport(child.id, 'forum_marketplace_reply_child')"><i class="fa-solid fa-flag"></i> Report</div>
                        </div>
                      </div>
                    </div>
                    <div class="time">
                      {{ formatDate(child.createdAt) }}
                    </div>
                  </div>
                  <ng-container *ngIf="child.isEdit">
                    <form (ngSubmit)="storeForumMessageEdit(child)" class="w-100">
                      <app-editor [hideToolbar]="true" [(innerValue)]="child.messageEdit"></app-editor>
                      <div class="mt-3 float-right">
                        <button type="button" (click)="child.isEdit = false" class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                        <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                      </div>
                    </form>
                  </ng-container>
                </div>
              </div>
            </div>

            <ng-container *ngIf="reply.isEdit">
              <form (ngSubmit)="storeForumMessageEdit(reply)" class="w-100">
                <app-editor [hideToolbar]="true" [(innerValue)]="reply.messageEdit"></app-editor>
                <div class="mt-3 float-right">
                  <button type="button" (click)="reply.isEdit = false" class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                  <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                </div>
              </form>
            </ng-container>

            <ng-container *ngIf="reply.showReplyBox">
              <form (ngSubmit)="storeForumMessageReply(null, reply)" class="w-100 mt-2">
                <app-editor [hideToolbar]="true" [(innerValue)]="reply.replyText"></app-editor>
                <div class="mt-3 float-right">
                  <button type="button" (click)="reply.showReplyBox = false; reply.showOption = false" class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                  <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit" [disabled]="detailForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send Reply</button>
                </div>
              </form>
            </ng-container>

            <!-- <ng-container *ngIf="reply.isEdit">
            <form (ngSubmit)="storeForumMessageEdit(reply.id)" class="w-100">
                <ckeditor [editor]="Editor" [data]="EditorData" [config]="EditorConfig"
                    [(ngModel)]="reply.messageEdit" name="ckEditorText" ngDefaultControl
                    (change)="onEditorChange($event)">
                </ckeditor>
                <div class="mt-3 float-right">
                    <button type="button" (click)="reply.isEdit = false" class="btn btn-danger mr-2"
                        [class.disabled]="reply.hasSubmit" [disabled]="reply.hasSubmit">
                        <i class="fa-solid fa-times"></i> Cancel
                    </button>
                    <button class="btn btn-primary" [class.disabled]="reply.hasSubmit"
                        [disabled]="reply.hasSubmit">
                        <i class="fa-solid fa-paper-plane"></i> Send
                    </button>
                </div>
            </form>
        </ng-container> -->
          </div>
          <!-- <div class="comments__card--right">

            <div
              class="comments__card--right__comments"
              *ngIf="reply?.replies.length != 0"
              (click)="reply.showReply = !reply.showReply"
            >
              <i class="fa-solid fa-arrow-alt-circle-down"></i>
            </div>
          </div> -->
        </div>

        <div class="forum-detail-post__reply">
          @if(userProfile) {
          <img [src]="imgUrl + userProfile" class="shadow-sm" />
          }@else {
          <div style="font-size: 0.75em;"></div>
          } 
          <input type="text" class="form-control" placeholder="Write Your Comments..." [(ngModel)]="detailForum.replyText" />
          <button class="btn btn-outline-secondary" (click)="isLogin ? storeForumMessageReply() : loginHere()"><i class="fa-solid fa-paper-plane"></i></button>
        </div>

        <div *ngIf="detailForum?.replies?.length < 1">
          <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i> There are no replies posted at this time</div>
        </div>

        <!-- <div class="my-3" *ngIf="isLogin == 0">
          <div class="alert alert-danger" role="alert">
            <div class="d-flex flex-column flex-md-row justify-content-between">
              <span class="my-auto">
                <i class="fa-solid fa-exclamation-circle"></i> Please log in
                first if you want to discuss in the
                <b>{{ shopForum?.userName }}</b> Forum
              </span>
              <button class="btn btn-sm btn-primary" (click)="loginHere()">
                Login Here !
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</section>
<ng-template #detailPost let-modal>
  <div id="forum_detail_post" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" class="forum-detail-post">
    <button class="btn btn-secondary mx-3 mb-3" [disabled]="forum?.hasSubmit" (click)="modalService.dismissAll()"><i class="fa-solid fa-times"></i> Close</button>
  </div>
</ng-template>
